import React from 'react';
import IForm from '../../../../types/IForm';
import { FormContext, FormUtils } from '../../../../components/molecules/Form';
import FormsRow, { FormsRowModifier } from '../../../../components/molecules/Form/components/FormsRow/FormsRow';
import LiveRegion from '../../../../components/atoms/LiveRegion/LiveRegion';
import Form from '../../../../components/molecules/Form/Form';
import { ButtonActionConfirm } from '../../../../components/molecules/Btn/ButtonWrapper';
import { InteractionStatus } from '../../../../types/InteractionStatus';
import { createFormElement } from '../../../../components/molecules/Form/FormFactory';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { Namespace } from '../../../../translation/namespace';
import { Strong } from '../../../../components/atoms/Strong/Strong';

type EditMetaDataFormProps = {
  form?: IForm;
  onSuccess: () => void;
};

export function EditMetaDataForm({ form, onSuccess }: EditMetaDataFormProps) {
  const { t } = useSonTranslation(Namespace.ImageGallery);
  if (!form) {
    return null;
  }

  return (
    <Form
      id="image-gallery-image-edit-metadata-form"
      onSuccess={() => {
        setTimeout(() => {
          onSuccess();
        }, 2000);
      }}
      model={form}
    >
      <FormContext.Consumer>
        {({ inputs, onChange, status, getStatus, hasChanges }) => (
          <>
            {inputs.alt &&
              createFormElement({
                labelHelpText: t('editForm.pictureDescriptionHelpText'),
              })(inputs.alt, 'pictureDescriptionHelpText', onChange, t('editForm.pictureDescriptionLabel'))}
            {inputs.caption &&
              createFormElement()(inputs.caption, 'pictureCaptionLabel', onChange, t('editForm.pictureCaptionLabel'))}
            {inputs.copyright &&
              createFormElement({
                labelHelpText: t('editForm.pictureCopyrightHelpText'),
              })(inputs.copyright, 'pictureCopyrightLabel', onChange, t('editForm.pictureCopyrightLabel'))}
            <FormsRow modifier={[FormsRowModifier.RIGHT, FormsRowModifier.NO_MARGIN]}>
              <ButtonActionConfirm
                type={
                  status === InteractionStatus.SUCCESS || status === InteractionStatus.SENDING || !hasChanges()
                    ? 'button'
                    : 'submit'
                }
                text={t('editForm.save')}
                ariaDisabled={
                  status === InteractionStatus.SUCCESS || status === InteractionStatus.SENDING || !hasChanges()
                }
              />
            </FormsRow>
            <LiveRegion invisible={false} htmlTag="div">
              {getStatus(
                {
                  [InteractionStatus.SENDING]: FormUtils.createStatusMessage(t('editForm.status.sending')),
                  [InteractionStatus.SUCCESS]: FormUtils.createStatusMessage(
                    <>
                      {t('editForm.status.success')}
                      <Strong> {t('editForm.status.successForward')}</Strong>
                    </>
                  ),
                  [InteractionStatus.FAIL]: FormUtils.createStatusMessage(t('editForm.status.fail')),
                },
                status
              )}
            </LiveRegion>
          </>
        )}
      </FormContext.Consumer>
    </Form>
  );
}
